var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 53.6663C19.0548 53.6663 16.667 51.2785 16.667 48.333H27.3337C27.3337 51.2785 24.9458 53.6663 22.0003 53.6663ZM43.3337 45.6663H0.666992V40.333L6.00033 37.6663V22.9997C6.00033 13.7677 9.78966 7.78101 16.667 6.14634V0.333008H27.3337V6.14634C34.211 7.77834 38.0003 13.7623 38.0003 22.9997V37.6663L43.3337 40.333V45.6663ZM22.0003 10.333C18.7461 10.1229 15.6077 11.5791 13.667 14.1997C12.0071 16.8252 11.1927 19.8967 11.3337 22.9997V40.333H32.667V22.9997C32.8078 19.8967 31.9934 16.8252 30.3337 14.1997C28.3929 11.5791 25.2545 10.1229 22.0003 10.333Z",
    fill: "#FFA800"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOutline);
export default __webpack_public_path__ + "static/media/notification_outline.ad6dd64754bae2dd538b0db4b1313091.svg";
export { ForwardRef as ReactComponent };